import { Button } from "antd";
import { useState } from "react";
import { Document, Page } from "react-pdf";

function PdfViewer({ url }) {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setPageNumber(1); // Reset to first page on load
    };

    const goToPreviousPage = () => {
        setPageNumber((prev) => Math.max(prev - 1, 1));
    };

    const goToNextPage = () => {
        setPageNumber((prev) => Math.min(prev + 1, numPages));
    };

    return (
        <div className="pdf-viewer">
            <div className="h-[60vh] overflow-auto">
                <Document
                    loading="Loading Assignment..."
                    file={url}
                    onLoadSuccess={onDocumentLoadSuccess}

                >
                    <Page pageNumber={pageNumber} />
                </Document>
            </div>

            <div className="flex justify-between items-center mt-4">
                <Button
                    type="default"
                    onClick={goToPreviousPage}
                    disabled={pageNumber <= 1}
                >
                    Previous
                </Button>
                <p>
                    Page {pageNumber} of {numPages}
                </p>
                <Button
                    type="default"
                    onClick={goToNextPage}
                    disabled={pageNumber >= numPages}
                >
                    Next
                </Button>
            </div>
        </div>
    );
}


export default PdfViewer